import { render, staticRenderFns } from "./order_merchant.vue?vue&type=template&id=af7634ba&scoped=true&"
import script from "./order_merchant.vue?vue&type=script&lang=js&"
export * from "./order_merchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7634ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af7634ba')) {
      api.createRecord('af7634ba', component.options)
    } else {
      api.reload('af7634ba', component.options)
    }
    module.hot.accept("./order_merchant.vue?vue&type=template&id=af7634ba&scoped=true&", function () {
      api.rerender('af7634ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/order_merchant.vue"
export default component.exports